import React, { useEffect, useState } from "react";
import "./StoreCredit.scss";

import { RiCoinsFill } from "react-icons/ri";

import { useLocation, useNavigate } from "react-router-dom";
import ROUTES from "../../../constants/routes";
import {
  addCustomerBalance,
  fetchCreditActivitiesByCustomer,
} from "../../../api/customers";
import Loader from "../../../components/Loader/Loader";
import { format, isToday, isYesterday, parseISO } from "date-fns";
import { useViewPortDetector } from "../../../helpers/viewPortDetector";
import { IoIosArrowBack } from "react-icons/io";
import { useForm } from "react-hook-form";
import CustomButton from "../../../components/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { updateOpenSubscriptionAd } from "../../../redux/features/subscription-slice";
import { toast } from "react-toastify";
import { FaChevronRight, FaPen } from "react-icons/fa6";
import useUserIsAllowed from "../../../helpers/userAuthorized";

const StoreCredit = ({ desktopView, selected, open }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const { currency } = useSelector((state) => state.organizationReducer.value);

  const { currentViewPort, isReady } = useViewPortDetector();

  const customerData = desktopView
    ? selected
    : location.state?.customerData || {};
  const customer_id = customerData?.id || null;

  const [creditLogs, setCreditLogs] = useState();
  const [creditLogsArray, setCreditLogsArray] = useState(false);
  const [loading, setLoading] = useState(false);

  const [openStoreAdd, setOpenStoreAdd] = useState(false);
  const [openStoreRemove, setOpenStoreRemove] = useState(false);
  const [openStoreOptions, setOpenStoreOptions] = useState(false);

  const groupLogsByDate = (dataArray) => {
    const groups = dataArray.reduce((acc, order) => {
      const orderDate = parseISO(order?.updated_at, "p");
      let group = "";

      if (isToday(orderDate)) {
        group = "Today";
      } else if (isYesterday(orderDate)) {
        group = "Yesterday";
      } else {
        // group = format(orderDate, "dd/MM/yyyy hh:mm a");
        group = format(orderDate, "dd/MM/yyyy");
      }

      if (!acc[group]) {
        acc[group] = [];
      }

      acc[group].push(order);
      return acc;
    }, {});

    return groups;
  };

  const getCustomerCreditActivities = () => {
    setLoading(true);
    fetchCreditActivitiesByCustomer(customer_id)
      .then((res) => {
        if (res.data?.length > 0) {
          setCreditLogsArray(res.data);
        } else {
          setCreditLogsArray([]);
        }
      })
      .catch((err) => {
        console.log("Error while fetching customer credit activities.", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (creditLogsArray?.length > 0) {
      const grouped_logs = groupLogsByDate(creditLogsArray);
      setCreditLogs(grouped_logs);
    } else {
      setCreditLogs(null);
    }
  }, [creditLogsArray]);

  useEffect(() => {
    if (!desktopView && currentViewPort === "desktop" && isReady) {
      navigate(ROUTES.customers.path, {
        state: { customerData: customerData },
      });
    } else {
      if (!customer_id) {
        navigate(ROUTES.customers.path);
      } else {
        getCustomerCreditActivities();
      }
    }
  }, [customer_id, desktopView, currentViewPort, isReady]);

  return (
    <>
      {loading && <Loader />}
      <div
        className={`store-credit ${
          desktopView ? (open ? "active" : "") : "active"
        }`}
      >
        <p className="main-heading container-wrapper">
          Store activities of {customerData?.name || "N/A"}
        </p>

        {creditLogs && (
          <div className="store-credit-logs container-wrapper">
            {Object.keys(creditLogs).map((group, i) => {
              return (
                <div className="item-group" key={i}>
                  <p className="title">{group}</p>
                  <div className="lists">
                    {creditLogs[group]?.map((item, index) => {
                      return (
                        <div className="item" key={index}>
                          <div className="left">
                            <p className="current">
                              Current Balance: {currency}
                              {Number(item?.current_balance).toFixed(2)}
                            </p>
                            <p className="previous">
                              Previous Balance: {currency}
                              {Number(item?.prev_balance).toFixed(2)}
                            </p>
                          </div>
                          <div className="right">
                            <p className="date">
                              {item?.updated_at
                                ? format(parseISO(item?.updated_at), "hh:mm a")
                                : ""}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="store-credit-wrapper">
          <div className="store-credit-details">
            <div className="left">
              <RiCoinsFill />
              <p>
                {currency}
                {Number(customerData?.current_balance).toFixed(2)}
              </p>
            </div>
            <div className="right">
              <p className="heading">Store Credit Available</p>
              <p className="content">Store Credit Expiring on 11/30/2024</p>
            </div>
          </div>
        </div>

        <StoreCreditOptions
          open={openStoreOptions}
          setOpen={setOpenStoreOptions}
          setOpenStoreAdd={setOpenStoreAdd}
          setOpenStoreRemove={setOpenStoreRemove}
        />

        <AddStoreCredit
          open={openStoreAdd}
          setOpen={setOpenStoreAdd}
          customerData={customerData}
          currency={currency}
          setCreditLogsArray={setCreditLogsArray}
          setOpenStoreOptions={setOpenStoreOptions}
        />

        <RemoveStoreCredit
          open={openStoreRemove}
          setOpen={setOpenStoreRemove}
          customerData={customerData}
          currency={currency}
          setCreditLogsArray={setCreditLogsArray}
          setOpenStoreOptions={setOpenStoreOptions}
        />

        {!creditLogs && (
          <div className="empty">
            <p>This customer has no store credit activities.</p>
          </div>
        )}

        <div
          className="navigation-back-button"
          onClick={() => {
            navigate(ROUTES.customers.path, {
              state: { customerSelected: customerData },
            });
          }}
        >
          <IoIosArrowBack />
        </div>

        <div className="store-credit-option-icon">
          <FaPen
            onClick={() => {
              setOpenStoreOptions(true);
            }}
          />
        </div>

        {openStoreOptions && (
          <div
            className="back-blur"
            onClick={() => {
              setOpenStoreOptions(false);
            }}
          ></div>
        )}
      </div>
    </>
  );
};

export default StoreCredit;

const StoreCreditOptions = ({
  open,
  setOpen,
  setOpenStoreAdd,
  setOpenStoreRemove,
}) => {
  const userIsAdministrator = useUserIsAllowed("administrator");
  const userIsAllowedToManageInventory = useUserIsAllowed("manage_inventory");

  const userIsAllowedToEditCredit =
    userIsAdministrator || userIsAllowedToManageInventory;

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`store-credit-options ${isVisible ? "active" : ""}`}>
      <p className="heading">Store Credit Options</p>
      <div
        className="opt-btn"
        onClick={() => {
          if (userIsAllowedToEditCredit) {
            setOpenStoreAdd(true);
            setOpenStoreRemove(false);
            // setOpen(false);
          } else {
            toast.dismiss(); toast.info(
              "You do not have sufficient permissions to perform this action. Please contact your administrator."
            );
          }
        }}
      >
        <p>Add Customer Balance</p> <FaChevronRight />
      </div>
      <div
        className="opt-btn"
        onClick={() => {
          if (userIsAllowedToEditCredit) {
            setOpenStoreRemove(true);
            setOpenStoreAdd(false);
            // setOpen(false);
          } else {
            toast.dismiss(); toast.info(
              "You do not have sufficient permissions to perform this action. Please contact your administrator."
            );
          }
        }}
      >
        <p>Remove Customer Balance</p> <FaChevronRight />
      </div>

      <div className="buttons">
        <CustomButton
          name={"Cancel"}
          color={"danger"}
          type={"button"}
          handleSubmit={() => {
            setOpen(false);
            setOpenStoreAdd(false);
            setOpenStoreRemove(false);
          }}
        />
      </div>
    </div>
  );
};

const AddStoreCredit = ({
  open,
  setOpen,
  customerData,
  currency,
  setCreditLogsArray,
  setOpenStoreOptions,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const balanceWatch = watch("balance");
  const [newBalance, setNewBalanace] = useState(
    Number(customerData?.current_balance).toFixed(2) || 0
  );

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    reset({
      balance: "",
    });
    setNewBalanace(Number(customerData?.current_balance).toFixed(2) || 0);
  }, [open]);

  useEffect(() => {
    setNewBalanace((prevBalance) => {
      const updatedBalance = (
        Number(customerData?.current_balance) + Number(balanceWatch)
      ).toFixed(2);
      return Number(updatedBalance);
    });

    if (balanceWatch !== 0) {
      clearErrors("balance");
    }
  }, [balanceWatch]);

  const handleAddBalance = (data) => {
    const creditData = {
      credit_amount: Number(data.balance || 0),
    };
    if (creditData.credit_amount > 0) {
      setSubmitting(true);
      addCustomerBalance(customerData?.id, creditData)
        .then((res) => {
          toast.dismiss(); toast.success(res.data?.message || "Customer balance updated.");
          if (res.data?.new_balance) {
            navigate("#", {
              state: {
                customerData: {
                  ...customerData,
                  current_balance: res.data?.new_balance,
                },
              },
            });
          }

          if (res.data?.store_activity) {
            setCreditLogsArray &&
              setCreditLogsArray((prev) => [res.data?.store_activity, ...prev]);
          }

          setOpen(false);
          setOpenStoreOptions(false);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss(); toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss(); toast.error("Error while adding customer's balance.");
          }

          if (err?.response?.data?.upgrade) {
            dispatch(updateOpenSubscriptionAd({ openAd: true }));
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      setError("balance", {
        type: "custom",
        message: "Balance cannot be zero or negative.",
      });
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <form
        onSubmit={handleSubmit(handleAddBalance)}
        className={`add-store-credit ${isVisible ? "active" : ""}`}
      >
        <h1 className="heading">Add Store Credit</h1>

        <div className="top-input">
          <p>{currency}</p>
          <input
            type="number"
            {...register("balance", {
              required: true,
            })}
            placeholder="0.00"
          />
          {errors["balance"]?.type && (
            <p className="error">
              {errors["balance"].type === "custom"
                ? errors["balance"].message
                : errors["balance"].type === "required"
                ? `Balance field is required.`
                : errors["Balance"]?.message || `Balance input is not valid.`}
            </p>
          )}
        </div>

        <p className="details">
          New Balance:{" "}
          <span>
            {currency}
            {Number(newBalance).toFixed(2)}
          </span>
        </p>

        <div className="buttons">
          <CustomButton
            name={"Cancel"}
            color={"danger"}
            type={"button"}
            handleSubmit={() => {
              setOpen(false);
            }}
            disabled={submitting}
          />

          <CustomButton
            name={"Add Balance"}
            color={"primary"}
            type={"submit"}
            handleSubmit={() => {}}
            disabled={submitting}
            loader={submitting}
          />
        </div>
      </form>
      {open && (
        <div
          className="back"
          onClick={() => {
            !submitting && setOpen(false);
          }}
        ></div>
      )}
    </>
  );
};

const RemoveStoreCredit = ({
  open,
  setOpen,
  customerData,
  currency,
  setCreditLogsArray,
  setOpenStoreOptions,
}) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setError,
    clearErrors,
    formState: { errors },
  } = useForm({});

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const balanceWatch = watch("balance");
  const [newBalance, setNewBalanace] = useState(
    Number(customerData?.current_balance).toFixed(2) || 0
  );

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    reset({
      balance: "",
    });
    setNewBalanace(Number(customerData?.current_balance).toFixed(2) || 0);
  }, [open]);

  useEffect(() => {
    setNewBalanace((prevBalance) => {
      const updatedBalance = (
        Number(customerData?.current_balance) - Number(balanceWatch)
      ).toFixed(2);
      return Number(updatedBalance);
    });

    if (balanceWatch !== 0) {
      clearErrors("balance");
    }
  }, [balanceWatch]);

  const handleAddBalance = (data) => {
    let creditData = {
      credit_amount: Number(data.balance || 0),
    };
    if (creditData.credit_amount > 0) {
      if (
        Number(creditData.credit_amount) > Number(customerData?.current_balance)
      ) {
        return setError("balance", {
          type: "custom",
          message: "Balance is greater than Customer's current balance.",
        });
      }
      creditData.credit_amount = -creditData.credit_amount;
      setSubmitting(true);
      addCustomerBalance(customerData?.id, creditData)
        .then((res) => {
          toast.dismiss(); toast.success(res.data?.message || "Customer balance updated.");
          if (res.data?.new_balance) {
            navigate("#", {
              state: {
                customerData: {
                  ...customerData,
                  current_balance: res.data?.new_balance,
                },
              },
            });
          }

          if (res.data?.store_activity) {
            setCreditLogsArray &&
              setCreditLogsArray((prev) => [res.data?.store_activity, ...prev]);
          }

          setOpen(false);
          setOpenStoreOptions(false);
        })
        .catch((err) => {
          if (err?.response?.data?.message) {
            if (err?.response?.data?.message === "User not authorized!") {
              toast.dismiss(); toast.error(
                "You do not have sufficient permissions to perform this action. Please contact your administrator."
              );
            } else {
              toast.dismiss(); toast.error(`${err?.response?.data?.message}`);
            }
          } else {
            toast.dismiss(); toast.error("Error while removing customer's balance.");
          }

          if (err?.response?.data?.upgrade) {
            dispatch(updateOpenSubscriptionAd({ openAd: true }));
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      setError("balance", {
        type: "custom",
        message: "Balance cannot be zero or negative",
      });
    }
  };

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (open) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [open, isVisible]);

  if (!shouldRender) return null;
  return (
    <>
      <form
        onSubmit={handleSubmit(handleAddBalance)}
        className={`add-store-credit ${isVisible ? "active" : ""}`}
      >
        <h1 className="heading">Remove Store Credit</h1>

        <div className="top-input">
          <p>{currency}</p>
          <input
            type="number"
            {...register("balance", {
              required: true,
            })}
            placeholder="0.00"
          />
          {errors["balance"]?.type && (
            <p className="error">
              {errors["balance"].type === "custom"
                ? errors["balance"].message
                : errors["balance"].type === "required"
                ? `Balance field is required.`
                : errors["Balance"]?.message || `Balance input is not valid.`}
            </p>
          )}
        </div>

        <p className="details">
          New Balance:{" "}
          <span>
            {currency}
            {Number(newBalance).toFixed(2)}
          </span>
        </p>

        <div className="buttons">
          <CustomButton
            name={"Cancel"}
            color={"danger"}
            type={"button"}
            handleSubmit={() => {
              setOpen(false);
            }}
            disabled={submitting}
          />

          <CustomButton
            name={"Remove Balance"}
            color={"primary"}
            type={"submit"}
            handleSubmit={() => {}}
            disabled={submitting}
            loader={submitting}
          />
        </div>
      </form>
      {open && (
        <div
          className="back"
          onClick={() => {
            !submitting && setOpen(false);
          }}
        ></div>
      )}
    </>
  );
};
